const SIM_DATA_UNITS = {
    KB: 1024,
    MB: 1048576,
    GB: 1073741824
};

export default SIM_DATA_UNITS;